"use client";

import { ErrorRecovery, type ErrorRecoveryProps } from "@/components/error-recovery";
import { localeFromPathname, localeSpec } from "@/i18n/config";
import "./globals.css";

export default function GlobalError(props: ErrorRecoveryProps) {
  const locale = typeof window === "undefined" ? "en" : localeFromPathname(window.location.pathname);

  return (
    <html dir={localeSpec(locale).direction} lang={locale} suppressHydrationWarning>
      <body>
        <ErrorRecovery {...props} />
      </body>
    </html>
  );
}
